// @ts-nocheck
import React, { ReactNode, ReactNodeArray } from "react";
import EpiComponent from "@episerver/spa-core/EpiComponent";
import AbroadContactUsBlockData from "../../../Models/Content/AbroadContactUsBlockData";
import AbroadContactUsMain from "./AbroadContactUsMain";

export default class AbroadContactUsBlock extends EpiComponent<AbroadContactUsBlockData> {
  public render(): ReactNode | ReactNodeArray | null {
    return (
      <AbroadContactUsMain
        iContent={this.props.data}
        context={this.getContext()}
      />
    );
  }
}
